/**
 * Returns up-to-2-character uppercase initials for a person's name.
 * Falls back to '?' for empty/whitespace input.
 *
 * Examples:
 *   initialsOf('Jane Doe')      // 'JD'
 *   initialsOf('jane mary doe') // 'JD'  (first + last)
 *   initialsOf('Cher')          // 'C'
 *   initialsOf('')              // '?'
 */
export const initialsOf = (value: string): string => {
  const parts = value.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};

/**
 * Splits a name into the two lines a desk label shows: first name, then last
 * name ("Maria del Carmen Chen" → ["Maria", "Chen"]). A single name has no
 * second line.
 */
export const deskNameLines = (value: string): [string, string | null] => {
  const parts = value.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return ['', null];
  if (parts.length === 1) return [parts[0], null];
  return [parts[0], parts[parts.length - 1]];
};
